var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gdp-and-growth-rate"},[_vm._m(0),_c('div',{staticClass:"chart-con"},[_c('v-chart',{ref:"bar-chart",staticClass:"bar-chart",attrs:{"id":"bar-chart","options":_vm.chartOption}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("广东省生产总值及增速")])])
}]

export { render, staticRenderFns }